@if (isActive) {
    <div [ngClass]="{ 'runner-odds-info': !isSports }">
        @if (isSpan) {
            @if (isWinMarketOdds) {
                <span class="win-market-odds">
                    @if (isGreyhounds) {
                        @if (oddsMarketName) {
                            @switch (runner.option?.priceType) {
                                @case (priceType.Fixed) {
                                    <div class="option-value">
                                        <strong>{{ runner.option!.price | msExternalPriceFormatter }}</strong>
                                        <div class="win-ew">
                                            {{ oddsMarketName }}
                                        </div>
                                    </div>
                                }
                                @case (priceType.StartingPrice) {
                                    <strong>{{ sitecore.betslip.messages.StartingPrice }}</strong>
                                }
                            }
                        } @else {
                            @switch (runner.option?.priceType) {
                                @case (priceType.Fixed) {
                                    <strong class="result-odds option-value">
                                        {{ runner.option!.price | msExternalPriceFormatter }}
                                    </strong>
                                }
                                @case (priceType.StartingPrice) {
                                    <strong class="result-odds">
                                        {{ sitecore.betslip.messages.StartingPrice }}
                                    </strong>
                                }
                            }
                        }
                    } @else {
                        @switch (runner.option?.priceType) {
                            @case (priceType.Fixed) {
                                <span class="option-value">
                                    {{ runner.option!.price | msExternalPriceFormatter }}
                                </span>
                            }
                            @case (priceType.StartingPrice) {
                                <span>{{ sitecore.betslip.messages.StartingPrice }}</span>
                            }
                        }
                    }
                </span>
            }
            @if (!isWinMarketOdds) {
                <span>
                    @switch (runner.option!.priceType) {
                        @case (priceType.Fixed) {
                            <span class="option-value">
                                {{ runner.option!.price | msExternalPriceFormatter }}
                            </span>
                        }
                        @case (priceType.StartingPrice) {
                            <span>{{ sitecore.betslip.messages.StartingPrice }}</span>
                        }
                    }
                </span>
            }
        }
        @if (!isSpan) {
            <div class="participant-cell cell-odds">
                @if (isOption) {
                    @if (runner.option?.priceType !== priceType.StartingPrice) {
                        <span class="result-odds option-value">
                            {{ runner.option!.price | msExternalPriceFormatter }}
                        </span>
                    }
                    @if (runner.option?.priceType === priceType.StartingPrice) {
                        <strong class="result-odds">
                            {{ sitecore.betslip.messages.StartingPrice }}
                        </strong>
                    }
                }
                @if (!isOption) {
                    @if (isWinMarketOdds) {
                        <span class="win-market-odds">
                            @if (runner.option?.participantPriceType !== priceType.StartingPrice) {
                                <strong class="option-value">
                                    {{ runner.option?.nativePrice | msExternalPriceFormatter }}
                                </strong>
                            }
                            @if (runner.option?.participantPriceType === priceType.StartingPrice) {
                                <strong>{{ sitecore.betslip.messages.StartingPrice }}</strong>
                            }
                        </span>
                    }
                    @if (!isWinMarketOdds) {
                        @if (runner.option?.participantPriceType !== priceType.StartingPrice) {
                            <span class="result-odds option-value">
                                {{ runner.option!.nativePrice | msNativePriceFormatter }}
                            </span>
                        }
                        @if (runner.option?.participantPriceType === priceType.StartingPrice) {
                            <strong class="result-odds">
                                {{ sitecore.betslip.messages.StartingPrice }}
                            </strong>
                        }
                    }
                }
            </div>
            @if (runner.priceHistory.length) {
                <div class="previous-odds">
                    @for (price of runner.priceHistory; track $index) {
                        <span>{{ price | msExternalPriceFormatter }}</span>
                    }
                </div>
            }
        }
    </div>
} @else {
    <div class="participant-cell cell-odds">
        <vn-icon class="racing-locked-icon" name="theme-locked-i" size="14"></vn-icon>
    </div>
}
